import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "flex justify-between space-x-2 tw"
};
const _hoisted_2 = {
  class: "w-1/2"
};
const _hoisted_3 = {
  class: "w-1/2"
};
const _hoisted_4 = {
  class: "flex"
};
const _hoisted_5 = {
  class: "w-1/2 ml-0"
};
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import LlSelect from '@/components/LlSelect.vue';
import { useAccountsStore } from '@/services/UserService/useAccountsStore';
import { useInvoiceState } from '@/modules/billing/review/editDraft/useInvoiceState';
import { useInvoiceEditorStore } from '@/modules/billing/invoice/services/useInvoiceEditorStore.js';
import LlTextarea from '@/components/LlTextarea.vue';
import LlTextField from '@/components/LlTextField.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { onMounted, reactive } from 'vue';
import { storeToRefs } from 'pinia';
export default {
  __name: 'CreditLineItem',
  emits: ['confirm', 'cancel'],
  setup(__props, {
    emit: __emit
  }) {
    const accountsStore = useAccountsStore();
    const invoiceState = useInvoiceState();
    const invoiceEditorStore = useInvoiceEditorStore();
    const {
      permissions
    } = storeToRefs(useMeStore());
    const {
      groups
    } = invoiceState;
    const {
      selectedLineItem
    } = invoiceEditorStore;
    const {
      onlyViewInvoice
    } = storeToRefs(useInvoiceEditorStore());
    const {
      getIsLocked
    } = useInvoiceState();
    const emit = __emit;
    const creditModalState = reactive({
      me: {},
      availableAccounts: [],
      form: {
        id: '',
        description: '',
        date: '',
        account: {},
        amount: '',
        creditNegative: ''
      }
    });
    onMounted(async () => {
      creditModalState.form = JSON.parse(JSON.stringify(selectedLineItem));
      creditModalState.form.creditNegative = -creditModalState.form.amount;
      creditModalState.availableAccounts = await accountsStore.listAccounts();
      (groups || []).forEach(group => {
        group.lineItems.forEach(li => {
          if (!li.account) return;
          if (!creditModalState.availableAccounts.find(a => a.id === li.account.id)) {
            creditModalState.availableAccounts.push(li.account);
          }
        });
      });
    });
    const confirm = () => {
      creditModalState.form.amount = -creditModalState.form.creditNegative;
      invoiceState.updateLineItem(creditModalState.form);
      emit('cancel');
    };
    const removeCreditAdjustmentFromGroup = group => {
      const idx = groups.findIndex(g => g == group);
      invoiceState.groups.splice(idx, 1);
      invoiceState.credit = !!invoiceState.groups.find(g => g.credit);
      invoiceState.updateLineItemsTotals();
    };
    const remove = () => {
      const adminFee = groups.filter(group => (group.type === 'adjustments' || group.name === 'Fees') && group.lineItems.some(lineItem => lineItem.computed));
      removeCreditAdjustmentFromGroup(adminFee);
      emit('cancel');
    };
    const handleAccountChange = () => {};
    const handleDescriptionChange = () => {};
    const handleDateChange = () => {};
    const undoItem = () => {};
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_list_item = _resolveComponent("v-list-item");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      return _openBlock(), _createBlock(_component_v_card, null, {
        prepend: _withCtx(() => [_createVNode(_component_v_card_title, {
          class: "headline"
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("Edit Credit", -1)]))]),
          _: 1
        })]),
        append: _withCtx(() => [_createVNode(_component_v_icon, {
          onClick: _cache[0] || (_cache[0] = $event => _unref(getIsLocked) || _unref(onlyViewInvoice) ? _ctx.$emit('cancel') : remove())
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("mdi-close", -1)]))]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_v_card_text, null, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(LlTextarea, {
            label: "Description",
            modelValue: creditModalState.form.description,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => creditModalState.form.description = $event),
            variant: "outlined",
            "hide-details": "true",
            onChange: handleDescriptionChange,
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(LlSelect, {
            modelValue: creditModalState.form.account,
            "onUpdate:modelValue": [_cache[2] || (_cache[2] = $event => creditModalState.form.account = $event), handleAccountChange],
            items: creditModalState.availableAccounts,
            "item-title": "name",
            "item-value": "id",
            density: "compact",
            "return-object": "",
            placeholder: "User",
            variant: "outlined",
            "hide-details": "true",
            label: "User",
            labelClass: "text-sm at-choose-client remove-outline",
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit,
            isAutocomplete: ""
          }, null, 8, ["modelValue", "items", "disabled"])]), _createElementVNode("div", _hoisted_3, [_createVNode(LlDatePicker, {
            modelValue: creditModalState.form.date,
            "onUpdate:modelValue": [_cache[3] || (_cache[3] = $event => creditModalState.form.date = $event), _cache[4] || (_cache[4] = $event => handleDateChange())],
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(LlTextField, {
            prefix: '$',
            type: 'number',
            label: "Credit Amount",
            modelValue: creditModalState.form.creditNegative,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => creditModalState.form.creditNegative = $event),
            disabled: _unref(onlyViewInvoice) || _unref(getIsLocked) || !_unref(permissions)?.billing?.edit
          }, null, 8, ["modelValue", "disabled"])])])]),
          _: 1
        }), _createVNode(_component_v_card_actions, null, {
          default: _withCtx(() => [_createVNode(_component_v_list_item, {
            class: "w-100"
          }, {
            prepend: _withCtx(() => [_createVNode(LlSecondaryButton, {
              class: "mr-2",
              onBtnClick: _cache[6] || (_cache[6] = $event => _unref(getIsLocked) || _unref(onlyViewInvoice) ? _ctx.$emit('cancel') : remove())
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(getIsLocked) || _unref(onlyViewInvoice) ? 'Close' : 'Cancel'), 1)]),
              _: 1
            }), !(_unref(onlyViewInvoice) || _unref(getIsLocked)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              class: "ml-2",
              onBtnClick: _cache[7] || (_cache[7] = $event => remove())
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Remove ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            append: _withCtx(() => [!(_unref(onlyViewInvoice) || _unref(getIsLocked)) ? (_openBlock(), _createBlock(LlSecondaryButton, {
              key: 0,
              color: "primary",
              variant: "flat",
              onBtnClick: _cache[8] || (_cache[8] = $event => confirm())
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode(" Apply ", -1)]))]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      });
    };
  }
};